export default __webpack_public_path__ + "static/media/bg_pc_quero-uma-agencia-1.78e8a0ab.png";